const DefaultWord = ({ content }: { content: string }) => {
  return <>{content}</>;
};

export default DefaultWord;
